export enum LocalStorageKey {
  HHCareer = 'hh_career',
}
